module.exports = __webpack_public_path__ + "static/img/晚班領班-潘宏典.6819413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/晚班領班-潘宏典.png
// module id = Hxwq
// module chunks = 1